import { useCallback } from "react";
import axios from "axios";
import { API } from "@/constants";

export const useEngagementTracker = () => {
  const trackEvent = useCallback((tool, action = 'view', metadata = {}) => {
    // Track engagement for analytics (works regardless of trial status)
    axios.post(`${API}/trial/track`, null, {
      params: { tool_used: tool, action, metadata }
    }).catch(() => {}); // Silent fail
  }, []);
  
  return { trackEvent };
};
